import React from 'react'
import { useRedirectRouter } from '../hooks/useRedirectRouter'

export const PageNotFound = () => {
  useRedirectRouter()
  return <div>404</div>
}
